import { Row, Col, Box, Button, TypoTooltip, Typography } from '@applift/factor'
import { CreativeInfo } from '../../../../models/Creative'
import styles from './styles.module.scss'

export interface PreviewFooterPropsTypes {
  creativeDetails: CreativeInfo
  displayActualSize?: boolean
}

export const PreviewFooter = (props: PreviewFooterPropsTypes) => {
  const { creativeDetails, displayActualSize } = props
  return creativeDetails && creativeDetails.nativeCreativeAttributes ? (
    <Box
      sx={!displayActualSize ? { width: 100, px: 16 } : { px: 16 }}
      className={styles.previewFooterWrapper}
    >
      <Box sx={{ display: 'flex', justifyContent: 'between' }}>
        <Box>
          <Box>
            <TypoTooltip>
              {creativeDetails.nativeCreativeAttributes?.title as string}
            </TypoTooltip>
          </Box>
          <Box>
            <TypoTooltip
              TypgraphyProps={{
                sx: { textColor: 'neutral-500' },
                variant: 'label',
              }}
            >
              {creativeDetails.nativeCreativeAttributes?.description as string}
            </TypoTooltip>
          </Box>
        </Box>
        <Box>
          {creativeDetails.nativeCreativeAttributes.cta.ctaText ? (
            <Button
              className={styles.creativesCTA}
              color="secondary"
              size="small"
              variant="outlined"
              sx={{ ml: 'auto' }}
              style={{ pointerEvents: 'none' }}
            >
              {creativeDetails.nativeCreativeAttributes.cta.ctaText ?? ''}
            </Button>
          ) : null}
        </Box>
      </Box>
      <Row sx={{ mt: 2 }}>
        <Col xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
          {creativeDetails.nativeCreativeAttributes?.brandIconSource && (
            <Box className={styles.brandIcon}>
              <img
                alt="icon"
                src={
                  creativeDetails.nativeCreativeAttributes
                    ?.brandIconSource as string
                }
              />
            </Box>
          )}

          {creativeDetails.nativeCreativeAttributes?.brandName ? (
            <Typography
              component="span"
              sx={{ textColor: 'neutral-500', fontSize: 12 }}
            >
              {creativeDetails.nativeCreativeAttributes?.brandName as string} |
              Sponsored
            </Typography>
          ) : null}
        </Col>
      </Row>
    </Box>
  ) : null
}
